import {Component} from 'react'
import {
  Container,
  Heading,
  Para,
  Input,
  Button,
  Container1,
  Container2,
  Label,
  Ul,
} from './styledComponents'

import GradientDirectionItem from '../GradientDirectionItem'

const gradientDirectionsList = [
  {directionId: 'TOP', value: 'top', displayText: 'Top'},
  {directionId: 'BOTTOM', value: 'bottom', displayText: 'Bottom'},
  {directionId: 'RIGHT', value: 'right', displayText: 'Right'},
  {directionId: 'LEFT', value: 'left', displayText: 'Left'},
]

class GradientGenerator extends Component {
  state = {
    directionInput: 'top',
    colorInputFirst: '#8ae323',
    colorInputSecond: '#014f7b',
    direction: 'top',
    colorFirst: '#8ae323',
    colorSecond: '#014f7b',
  }

  toSetDirection = direction => {
    this.setState({directionInput: direction})
  }

  setFirstcolor = event => {
    this.setState({colorInputFirst: event.target.value})
  }

  setSecondcolor = event => {
    this.setState({colorInputSecond: event.target.value})
  }

  toGenerate = () => {
    const {directionInput, colorInputFirst, colorInputSecond} = this.state
    this.setState({
      direction: directionInput,
      colorFirst: colorInputFirst,
      colorSecond: colorInputSecond,
    })
  }

  render() {
    const {
      direction,
      colorFirst,
      colorSecond,
      directionInput,
      colorInputFirst,
      colorInputSecond,
    } = this.state
    console.log(direction, colorFirst, colorSecond)
    return (
      <Container
        direction={direction}
        colorFirst={colorFirst}
        colorSecond={colorSecond}
        data-testid="gradientGenerator"
      >
        <Heading>Generate a CSS Color Gradient</Heading>
        <Para>Choose Direction</Para>
        <Ul>
          {gradientDirectionsList.map(each => (
            <GradientDirectionItem
              key={each.directionId}
              props={each}
              toSetDirection={this.toSetDirection}
              directionInput={directionInput}
            />
          ))}
        </Ul>

        <Para>Pick the Colors</Para>
        <Container1>
          <Container2>
            <Para htmlFor="colorf">{colorInputFirst}</Para>
            <Input
              type="color"
              id="colorf"
              value={colorInputFirst}
              onChange={this.setFirstcolor}
            />
          </Container2>
          <Container2>
            <Para htmlFor="colors">{colorInputSecond}</Para>
            <Input
              type="color"
              id="colors"
              value={colorInputSecond}
              onChange={this.setSecondcolor}
            />
          </Container2>
        </Container1>
        <Container1>
          <Button type="button" onClick={this.toGenerate}>
            Generate
          </Button>
        </Container1>
      </Container>
    )
  }
}
export default GradientGenerator
